import { Directive, ElementRef, HostListener, Input, Renderer } from '@angular/core';

import { FavoriteService, LogService } from './../';

@Directive({
  selector: '[favorite]'
})
export class FavoriteDirective {
  private el: HTMLElement;
  item: any;

  @Input('itemtype') inputType: string;

  constructor(el: ElementRef, private renderer: Renderer, private logger: LogService, private service: FavoriteService) {
    this.el = el.nativeElement;
  }


  @Input()
  set favorite(item: any) {
    this.item = item;
    try {
      if (this.item.userData.favorited) {
        this.renderer.setElementProperty(this.el, 'src', '../img/star-filled.svg');
        this.renderer.setElementProperty(this.el, 'title', 'Favorited');
      } else {
        this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
        this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
      }
    } catch (ex) {
      this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
      this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
    }
  }
  @HostListener('mouseenter') onMouseEnter() {

  }

  @HostListener('mouseleave') onMouseLeave() {
    this.highlight(null);
  }

  @HostListener('click') onClick() {
    try {
      if (!this.service.app.isLoggedIn) {
        this.service.showSignInError();
        return;
      }
      this.renderer.setElementClass(this.el, 'loading', true);
      if (this.item.userData.favorited) {
        this.callUnFavorite();
      } else {
        this.callFavorite();
      }
    } catch (ex) {
      this.service.showSignInError();
    }
  }

  private highlight(color: string) {
    this.el.style.backgroundColor = color;
  }

  callFavorite() {
    this.logger.log('favorite.directive', 'callFavorite', this.item);
    this.service.favorite(this.inputType, this.item.id).then((result) => {
      this.setFavorite();
      this.end();
    }).catch(err => {
      this.end();
    });
  }

  callUnFavorite() {
    this.logger.log('favorite.directive', 'callUnFavorite', this.item);
    this.service.unfavorite(this.inputType, this.item.id).then((result) => {
      this.setUnFavorite();
      this.end();
    }).catch(err => {
      this.end();
    });
  }

  setFavorite() {
    this.item.userData.favorited = true;
    this.renderer.setElementProperty(this.el, 'src', '../img/star-filled.svg');
    this.renderer.setElementProperty(this.el, 'title', 'Favorited');

    if (this.inputType === 'port') {
      this.service.app.setPort(this.item);
    } else if (this.inputType === 'vessel') {
      this.service.app.setVessel(this.item);
    } else if (this.inputType === 'carrier') {
      this.service.app.setCarrier(this.item);
    }
  }

  setUnFavorite() {
    this.item.userData.favorited = false;
    this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
    this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
    // could probably set an array and then only use one loop
    try {
      if (this.inputType === 'port') {
        for (let current = 0; current < this.service.app.ports.length; current++) {
          if (this.service.app.ports[current].id === this.item.id) {
            this.service.app.ports.splice(current, 1);
          }
        }
      } else if (this.inputType === 'vessel') {
        for (let current = 0; current < this.service.app.vessels.length; current++) {
          if (this.service.app.vessels[current].id === this.item.id) {
            this.service.app.vessels.splice(current, 1);
          }
        }
      } else if (this.inputType === 'carrier') {
        for (let current = 0; current < this.service.app.carriers.length; current++) {
          if (this.service.app.carriers[current].id === this.item.id) {
            this.service.app.carriers.splice(current, 1);
          }
        }
      }
    } catch (ex) {
      this.logger.log('favorite.directive', 'setUnFavorite', 'could not unfavorite');
    }
  }

  end() {
    this.renderer.setElementClass(this.el, 'loading', false);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/directives/favorite.directive.ts